import { render } from "./CurrencyIcons.vue?vue&type=template&id=609b75da&scoped=true"
import script from "./CurrencyIcons.vue?vue&type=script&lang=js"
export * from "./CurrencyIcons.vue?vue&type=script&lang=js"

import "./CurrencyIcons.vue?vue&type=style&index=0&id=609b75da&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-609b75da"]])

export default __exports__